import customSelectStyle from '../customSelectStyle'
import { text } from '../../app'

const individualTenantPageStyle = {
  ...customSelectStyle,

  regularText: {
    ...text,
  },
}

export default individualTenantPageStyle
